module.exports = __webpack_public_path__ + "static/media/fullKit.111cbcd0.mp4";